// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonIdentityPicker = {
  treeTitle: "組織",
  treeSearchPlaceholder: "組織を検索",
  treeLoading: "組織を読み込み中",
  treeEmpty: "選択可能な組織はありません",
  tableTitlePrefix: "ユーザー一覧",
  selectOrganization: "組織を選択してください",
  organizationNode: "組織ユニット",
  selectedUsersTitle: "選択済みメンバー",
  selectedUsersEmpty: "メンバーが選択されていません",
  pickMembersFromOrganization: "組織からメンバーを選択",
  emptyInCurrentScope: "現在の組織範囲に追加可能なメンバーはいません",
  emptyBeforeOrganization: "先に組織を選択してください",
  loadDataFailed: "組織選択データの読み込みに失敗しました",
  missingMembershipListApi: "組織メンバーの読み込みに失敗しました：メンバー一覧 API がありません",
  loadMembersFailed: "組織メンバーの読み込みに失敗しました",
  loadUserDetailsFailed: "ユーザー詳細の読み込みに失敗しました",
  searchField: "{field}を検索",
  columns: {
    allOrganizationMemberships: "すべての組織所属",
  },
  actions: {
    remove: "削除",
  },
} as const;
